import React, { useState } from 'react';
import {
  Button, Card, Col, Form, Row,
} from 'react-bootstrap';
import { status as BS, state as BST } from '../../helpers/buy';
import FileCard from '../common/FileCard';
import api from '../../api';
import { dateRenderer } from '../../services/formatSvc';

/**
 *
 * @param className
 * @param buy
 * @param readOnly {boolean} Вид карточки: полностью на просмотр (true) или в виде формы (false)
 * @param editOnly {boolean} Тип редактирования: вынесение решения Утвердить/Отклонить (false) или только редактирование атрибутов вынесенного решения
 * @param onExpertsDecision
 * @param onChange
 * @param handleEdit
 * @param handleSubmit
 * @param handleDecline
 * @returns {JSX.Element}
 * @constructor
 */
export default function ApprovalDataCard({
  className, buy, readOnly, editOnly, onExpertsDecision, onChange, handleEdit, handleSubmit, handleDecline,
}) {
  const handleFileChange = async ({ target }) => {
    const newFile = target.files.length ? target.files[0] : null;
    if (newFile) {
      onChange(newFile, 'approvalFile');
    }
  };
  const handleFileRemove = async () => {
    onChange(null, 'approvalFileId');
  };

  return (
    <Card className={className}>
      <Card.Header as={Card.Title} className="p-4">
        Решение по закупке
      </Card.Header>
      <Card.Body className="p-4">
        { readOnly
                && (
                <>
                  <Row className="mb-4">
                    <Col md={6}>
                      <Card.Subtitle className="mb-2 text-muted">Тип документа</Card.Subtitle>
                      <Card.Text>{buy.approvalType === 'byProt' ? 'Протокол' : buy.approvalType === 'byNote' ? 'СЗ' : ''}</Card.Text>
                    </Col>
                    <Col md={6}>
                      <Card.Subtitle className="mb-2 text-muted">Реквизиты документа</Card.Subtitle>
                      <Card.Text>
                        №
                        {buy.approvalNum}
                        {' '}
                        от
                        {dateRenderer(buy.approvalDate)}
                      </Card.Text>
                    </Col>
                  </Row>
                  <Row className="mb-4">
                    <Col md={12}>
                      <Card.Subtitle className="mb-2 text-muted">Рекомендации</Card.Subtitle>
                      <Card.Text>{buy.recommendations || 'не указано'}</Card.Text>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      {buy.approvalFileId && <FileCard file={buy.approvalFile} readOnly />}
                    </Col>
                  </Row>
                </>
                )}
        { !readOnly
                && (
                <>
                  <Row className="mb-4">
                    <Form.Group as={Col} md="12">
                      <Form.Check
                        disabled={editOnly}
                        onChange={() => onChange('byNote', 'approvalType')}
                        checked={buy.approvalType === 'byNote'}
                        type="radio"
                        id="radio-by-note"
                        label="СЗ"
                        inline
                      />
                      <Form.Check
                        disabled={editOnly}
                        onChange={() => onChange('byProt', 'approvalType')}
                        checked={buy.approvalType === 'byProt'}
                        type="radio"
                        id="radio-by-prot"
                        label="Протокол"
                        inline
                      />
                    </Form.Group>
                  </Row>
                  <Row className="mb-4">
                    <Form.Group as={Col} md="12">
                      <Form.Label>Рекомендации</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        value={buy.recommendations}
                        onChange={(e) => onChange(e.target.value, 'recommendations')}
                      />
                    </Form.Group>
                  </Row>

                  <Row className="mb-4">
                    <Form.Group as={Col} md="4">
                      <Form.Label>Дата документа</Form.Label>
                      <Form.Control
                        type="date"
                        readOnly={editOnly}
                        value={buy.approvalDate}
                        onChange={(e) => onChange(e.target.value, 'approvalDate')}
                      />
                    </Form.Group>
                    <Form.Group as={Col} md="8">
                      <Form.Label>Номер документа</Form.Label>
                      <Form.Control
                        readOnly={editOnly}
                        value={buy.approvalNum}
                        onChange={(e) => onChange(e.target.value, 'approvalNum')}
                      />
                    </Form.Group>
                  </Row>
                  <Row className="mb-4">
                    {buy.approvalFileId && <FileCard file={buy.approvalFile} onRemove={handleFileRemove} />}
                    {!buy.approvalFileId
                        && (
                        <Form.Group as={Col} md="12">
                          <Form.Label>Файл СЗ/протокола</Form.Label>
                          <Form.Control onChange={handleFileChange} type="file" />
                        </Form.Group>
                        )}
                  </Row>
                  <Row>
                    <Form.Group as={Col}>
                      {!readOnly && !editOnly && <Button className="me-2" variant="success" onClick={handleSubmit}>Утвердить</Button>}
                      {!readOnly && !editOnly && <Button className="me-2" variant="outline-danger" onClick={handleDecline}>Отклонить</Button>}
                      {editOnly && <Button className="me-2" variant="outline-secondary" onClick={handleEdit}>Сохранить решение</Button>}
                    </Form.Group>
                  </Row>
                </>
                )}
      </Card.Body>
    </Card>
  );
}
